import React from 'react';
import { usePage } from '@inertiajs/react'

import { ceil, multiply } from 'lodash'
import { Input, Typography } from '@material-tailwind/react'

import DatePicker from '@/Shared/DatePicker'
import LoadingButton from '@/Shared/LoadingButton'
import DeleteButton from '@/Shared/DeleteButton'

import { getLabel } from '@/utils'

export default function ({
    handleSubmit,
    remaining_quantity,
    item,
    data,
    setData,
    errors,
    processing,
    consumable,
    isEdit,
    isDeleted,
    destroy
}) {
    const {
        auth: {
            user: { role }
        }
    } = usePage().props

    function getHelperText() {
        if (item === 'normal_waste_21_bag') {
            return 'Enter Bags Quantity (30 Bags = 1 KG)'
        }

        if (item === 'normal_waste_30_bag') {
            return 'Enter Bags Quantity (16 Bags = 1 KG)'
        }

        if (item === 'normal_waste_39_bag') {
            return 'Enter Bags Quantity (8 Bags = 1 KG)'
        }

        return '';
    }

    function getRemainingQuantity() {
        if (item === 'normal_waste_21_bag') {
            return ceil(multiply(remaining_quantity, 30))
        }

        if (item === 'normal_waste_30_bag') {
            return ceil(multiply(remaining_quantity, 16))
        }

        if (item === 'normal_waste_39_bag') {
            return ceil(multiply(remaining_quantity, 8))
        }

        return remaining_quantity;
    }

    return (
        <form name="createForm" onSubmit={handleSubmit} className="mt-8">
            <div className="flex flex-col gap-4 md:flex-row">
                <Input size="lg" label="Item" value={getLabel(item)} disabled />

                <Input
                    size="lg"
                    label="Quantity"
                    name="quantity"
                    value={getRemainingQuantity()}
                    disabled
                />
            </div>

            <div className="mt-6 flex flex-col gap-4 md:flex-row">
                <DatePicker
                    date={data.date}
                    minDate={consumable && consumable[`${item}_arrived_date`]}
                    setDate={date => setData('date', date)}
                    disabled={role === '0'}
                />

                <div className="w-full">
                    <Input
                        size="lg"
                        label="Quantity"
                        name="quantity"
                        type="number"
                        max={getRemainingQuantity()}
                        error={errors.quantity}
                        value={data.quantity}
                        onChange={e => setData('quantity', e.target.value)}
                    />

                    <Typography
                        variant="small"
                        color="gray"
                        hidden={getHelperText() === ''}
                        className="mt-2 flex items-center gap-1 font-normal"
                    >
                        {getHelperText() !== '' && (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                className="-mt-px h-4 w-4"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 01.67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 11-.671-1.34l.041-.022zM12 9a.75.75 0 100-1.5.75.75 0 000 1.5z"
                                    clipRule="evenodd"
                                />
                            </svg>
                        )}
                        {getHelperText()}
                    </Typography>
                </div>
            </div>

            <div className="mt-8 flex items-center justify-between border-t border-gray-200 bg-gray-100 px-8 py-4">
                {isEdit && !isDeleted && (
                    <DeleteButton onDelete={destroy}>Delete Entry</DeleteButton>
                )}

                <LoadingButton
                    loading={processing}
                    type="submit"
                    className="btn-indigo"
                >
                    {isEdit ? 'Update' : 'Add'} Record
                </LoadingButton>
            </div>
        </form>
    )
}
